<template>
	<div>
		<div class="rating-summary">
			<div class="average-rating">
				<span class="big-rating" itemprop="ratingValue">{{ reviewsStore.averageRating.toFixed(2).replace('.', ',') }} / 5</span>
				<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
				<span class="rating-text has-text-weight-bold" itemprop="reviewRating">{{ reviewsStore.ratingText }}</span>
				<small><span itemprop="ratingCount">{{ reviewsStore.reviews.total }}</span> Bewertungen</small>
			</div>
			<div class="rating-bars">
				<div v-for="n in 5" :key="n" class="rating-bar-item">
					<span>{{ 6 - n }} <span class="is-hidden-mobile">Sterne</span></span>
					<b-progress
						:type="n === 1 ? 'is-success' : ''"
						:value="getRatingPercentage(6-n)"
						size="is-small"
					></b-progress>
					<!--					<span>{{ getRatingCount(6 - n) }}</span>-->
					<span>{{ getRatingPercentage(6 - n).toFixed(2).replace('.', ',') }}%</span>
				</div>
				<div>
				</div>
				<div style="cursor:pointer" @click="show.reasons_full = !show.reasons_full">Mehr Informationen einblenden</div>
			</div>
		</div>
		<div>

		</div>
		<b-notification v-if="show.reasons_full"
			aria-close-label="Close notification"
			has-icon
			type="is-info is-light"
		>
			<b>Notenberechnung auf Basis der Sternvergabe</b><br>
			5.00 - 4.50: Sehr gut<br>
			4.49 - 3.50: Gut<br>
			3.49 - 2.50: Befriedigend<br>
			2.49 - 1.50: Ausreichend<br>
			1.49 - 1.00: Mangelhaft<br><br>
			<b>Woher stammen die Bewertungen?</b><br>
			<p>
				Unsere Bewertungen stammen von verschiedenen renommierten Plattformen wie Trustpilot, TrustShops und weiteren führenden unabhängigen Bewertungsportalen in Deutschland. Wir haben keinerlei Einfluss auf die Veröffentlichung dieser Bewertungen, da diese auf unabhängigen Plattformen erfolgt. Nach ihrer Bestellung haben Kunden die Möglichkeit, eine authentische Bewertung abzugeben, die anschließend direkt auf der jeweiligen Plattform veröffentlicht wird.
			</p>
			<br>
			<b>Unsere online Bewertungsprofile</b><br>
			<p>Transparenz und der direkte Dialog mit unseren Kunden sind für uns selbstverständlich.</p>
			<review-plattform-boxes/>
		</b-notification>
	</div>
</template>
<script setup>
import {useReviewsStore} from "@/store/reviews";

const reviewsStore = useReviewsStore()
// eslint-disable-next-line no-undef
defineExpose({reviewsStore})

</script>
<script>

export default {
	name: 'ReviewSummary',
	components: {},
	data() {
		return {
			isModalActive: false,
			isCalModalActive: false,
			visibleReviews: [],
			page: 1,
			perPage: 10,
			isLoadingMore: false,
			show: {
				reasons_full: false,
			},
		}
	},
	mounted() {
		this.initReviews();
	},
	computed: {
		// ratingDistribution() {
		// 	const distribution = {5: 0, 4: 0, 3: 0, 2: 0, 1: 0};
		// 	this.reviews.forEach(review => {
		// 		const rating = parseInt(review.rating);
		// 		if (rating >= 1 && rating <= 5) {
		// 			distribution[rating]++;
		// 		}
		// 	});
		// 	return distribution;
		// },
	},
	methods: {
		async initReviews() {
			if (this.shouldFetchReviews) {
				await this.fetchReviews();
			}
			this.loadMoreReviews();
		},
		loadMoreReviews() {
			if (this.isLoadingMore) return;

			this.isLoadingMore = true;
			const start = (this.page - 1) * this.perPage;
			const end = this.page * this.perPage;
			this.visibleReviews = [...this.visibleReviews, ...this.reviewsStore.reviews.items.slice(start, end)];
			this.page++;
			this.isLoadingMore = false;

			// scroll in "reviews-list" a bit down
			const reviewsList = document.querySelector('.reviews-list');
			if (reviewsList) {
				setTimeout(() => {
					reviewsList.scrollBy({
						top: 250,
						behavior: 'smooth',
					});
				}, 50); // Timeout von 500ms
			}
		},
		getRatingPercentage(stars) {
			return (this.reviewsStore.ratingCountStars(stars) / this.reviewsStore.reviews.total) * 100;
		},

	},

	beforeMount() {

	},
}
</script>

<style scoped>
.rating-summary {
	display: flex;
	gap: 40px;
}

.average-rating {
	text-align: center;
}

.big-rating {
	font-size: 32px;
	font-weight: bold;
	color: #363636;
}

.rating-bars {
	flex-grow: 1;
	font-size: 12px;
}

.rating-bar-item {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 5px;
}

.rating-bar-item .b-progress {
	flex-grow: 1;
}

.rating-text {
	display: block;
	font-size: 18px;
	color: #666;
	margin: 4px 0;
}

.progress-wrapper {
	//flex-grow: 1;
	display: block;
	margin-bottom: 0;
	width: 70%;
}


.card .media:not(:last-child) {
	margin-bottom: .5rem;
}

</style>
